import { useState, useEffect } from "react";

import { useAuth } from "../context/AuthContext";

const usePermissions = () => {
  const { state: authState } = useAuth();
  const [permissions, setPermissions] = useState({
    user: true,
    fieldSupervisor: false,
    admin: false,
    superAdmin: false,
    webEditor: false,
    allFollowupsPermissions: false,
  });

  useEffect(() => {
    const userSecurities = authState?.user?.userSecurities;
    const employeeNumber = authState?.user?.employeeNumber;

    if (Array.isArray(userSecurities)) {
      // Special employee numbers that should have access to all followups
      const specialFollowupAccess = ["9098", "11101"];
      const hasSpecialFollowupAccess = specialFollowupAccess.includes(employeeNumber?.trim());

      setPermissions((prev) => ({
        ...prev,
        [userSecurities[0]]: true,
        // Grant all followups permissions to webEditor or special employee numbers
        allFollowupsPermissions: userSecurities[0] === "webEditor" || hasSpecialFollowupAccess,
      }));
    }
  }, [authState]);

  return permissions;
};

export default usePermissions;
